import { render } from "./VerCatalogo.vue?vue&type=template&id=8bc7316c"
import script from "./VerCatalogo.vue?vue&type=script&lang=js"
export * from "./VerCatalogo.vue?vue&type=script&lang=js"

import "./VerCatalogo.vue?vue&type=style&index=0&id=8bc7316c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__